import { formatUnits } from "viem";

export const formatUnitsFixed = (
  balance: bigint,
  decimals: number,
  dp?: number,
  roundingMode: 'ROUND_HALF_UP' | 'ROUND_DOWN' | 'ROUND_UP' = 'ROUND_DOWN',
  padZero: boolean = true
) => {
  const formatted = formatUnits(balance, decimals);
  let [integerPart, decimalPart = ''] = formatted.split('.');

  if (dp !== undefined) {
    if (dp === 0) {
      // Handle rounding for integer part
      if (
        decimalPart[0] &&
        ((roundingMode === 'ROUND_HALF_UP' && BigInt(decimalPart[0]) >= 5n) ||
          (roundingMode === 'ROUND_UP' && BigInt(decimalPart[0]) > 0n))
      ) {
        integerPart = (BigInt(integerPart) + 1n).toString();
      }
      return integerPart;
    }

    if (decimalPart.length > dp) {
      const roundDigit = decimalPart[dp];
      let truncatedDecimal = decimalPart.slice(0, dp);

      if (roundingMode === 'ROUND_HALF_UP') {
        if (BigInt(roundDigit) >= 5n) {
          truncatedDecimal = (BigInt(truncatedDecimal) + 1n).toString().padStart(dp, '0');
        }
      } else if (roundingMode === 'ROUND_UP') {
        if (BigInt(roundDigit) > 0n) {
          truncatedDecimal = (BigInt(truncatedDecimal) + 1n).toString().padStart(dp, '0');
        }
      }
      // For 'ROUND_DOWN', no change needed as we simply truncate

      // Handle carry-over from decimal to integer part
      if (truncatedDecimal.length > dp) {
        integerPart = (BigInt(integerPart) + 1n).toString();
        truncatedDecimal = '0'.repeat(dp);
      }

      return `${integerPart}.${truncatedDecimal}`;
    } else {
      if (padZero) {
        // Pad with zeros if necessary
        const paddedDecimal = decimalPart.padEnd(dp, '0');
        return `${integerPart}.${paddedDecimal}`;
      }
      return decimalPart ? `${integerPart}.${decimalPart}` : integerPart;
    }
  }

  return formatted
};
